export default __webpack_public_path__ + "static/media/loadingBays.4b787d34.svg";